import type { ApiErrorPayload } from '../types/apiError'

export function extractApiErrorMessage(
  payload: ApiErrorPayload | null,
  status: number,
  fallbackMessage: string = 'Ошибка API.'
): string {
  if (!payload) {
    return fallbackMessage || `Ошибка API: ${status}`
  }

  if (typeof payload.message === 'string' && payload.message.trim()) {
    return payload.message.trim()
  }

  const modelErrors = payload.errors
  if (modelErrors && typeof modelErrors === 'object') {
    const firstFieldErrors = Object.values(modelErrors)
      .find((value) => Array.isArray(value) && value.length > 0)

    if (Array.isArray(firstFieldErrors)) {
      const firstMessage = firstFieldErrors.find((value) => typeof value === 'string' && value.trim())
      if (firstMessage) {
        return firstMessage.trim()
      }
    }
  }

  if (typeof payload.title === 'string' && payload.title.trim()) {
    return payload.title.trim()
  }

  return fallbackMessage || `Ошибка API: ${status}`
}
